import React from 'react';
import strings from "../../localization";
import { bindActionCreators } from "redux";
import { withSnackbar } from "notistack";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import * as Actions from "../../actions/Actions";
import Page from '../../common/Page';
import { getYears } from '../../util/DateUtil';
import SelectControl from '../../components/controls/SelectControl';
import IconButton from "@material-ui/core/IconButton";
import { generateFuneralAndUrnPerMonth } from '../../services/report/ReportService';
import { downloadReport } from '../../util/ReviewsUtil';
import { getAllGraveyards } from '../../services/graveyard/GraveyardService';
import { generateFuneralsForGraveFieldsAndSelectedGraveyard } from '../../services/report/ReportService';

class FuneralGraveFieldAndSelectedGraveyardList extends Page {

  constructor(props) {
    super(props);


    this.state = {
      ...this.state,
      data: {
        graveyard: { value: "none" },
      },
      graveyards: []
    }

  }



  fetchData() {
    let data = {
      graveyard: this.state.data.graveyard ? this.state.data.value : "",
      generate: false,
      searchParam: this.state.searchData.search,
      page: this.state.searchData.page - 1,
      size: this.state.searchData.perPage,
      companyId: this.state.companyId,
      sort: this.state.sortBy,
    };
  }

  getGraveyards() {
    getAllGraveyards().then(response => {
      let graveyardCodes = [];
      for (let obj of response.data.entities) {
        graveyardCodes.push({
          name: obj.code + " - " + obj.name,
          value: obj.name,
          code: obj.code
        });
      }

      this.setState({ graveyards: graveyardCodes });
    });
  }

  componentDidMount() {
    this.setState({
      companyId: this.props.auth.user.company.id,
    }, () => {
      this.fetchData();
      this.getGraveyards();
    });
  }

  componentWillReceiveProps(nextProps) {
    strings.setLanguage(nextProps.auth.user.language);
  }

  renderText() {
    let styles = {
      marginLeft: '20px',
    };
    return (
      <div style={styles}>
        <h1> {strings.review.tables.funerals.funeralsForSelectedGraveyard}</h1>
      </div>
    );
  }


  renderFilter() {
    let styles = {
      marginLeft: '20px',
      width: '200px',
    };
    return (

      <div style={styles}>
        <SelectControl
          options={this.state.graveyards}
          selected={this.state.data.graveyard}
          onChange={this.changeData}
          label={strings.review.tables.funerals.selectedGraveyard}
          name={"graveyard"}
          nameKey={"name"}
          valueKey={"value"}
          codeKey={"code"}
        />
      </div>

    );
  }



  renderButton() {
    let data = {
      graveyardCode: this.state.data.graveyard ? this.state.data.graveyard.code : "",
      companyId: this.state.companyId,
      userId: this.props.auth.user.id
    };

    let styles = {
      marginLeft: '20px',
    };

    return (
      <div className="report-button" style={styles}>
        <IconButton onClick={() => this.generateFuneralsForGraveFieldsAndSelectedGraveyard(data, strings.review.tables.funerals.funeralsListPDFNameForSelectedGraveyard)} disabled={this.state.data.graveyard.value == 'none'}>
          {strings.review.buttons.generateReport}
        </IconButton>
      </div>

    );
  }

  generateFuneralsForGraveFieldsAndSelectedGraveyard(data, value) {

    generateFuneralsForGraveFieldsAndSelectedGraveyard(data).then(response => {
      if (!response.ok) {

        return;
      }

      this.props.enqueueSnackbar(strings.review.tables.funerals.funeralsListPDF, { variant: 'success' });
      downloadReport(response, value);
    })

  }

  render() {
    return (
      <div>
        {
          this.renderText()
        }
        {
          this.renderFilter()
        }
        {
          this.renderButton()
        }
      </div>
    );
  }



}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(FuneralGraveFieldAndSelectedGraveyardList)));
